module.exports = __webpack_public_path__ + "img/metas-ano-mes.75b53384.png";